// Valor em reais por extenso, pra recibos ("cento e vinte reais e cinquenta
// centavos"). Vai até a casa dos bilhões, que cobre qualquer recibo real.

const UNIDADES = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove',
  'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos',
  'setecentos', 'oitocentos', 'novecentos'];

// 0 a 999.
const ate999 = (n: number): string => {
  if (n === 0) return '';
  if (n === 100) return 'cem';
  const c = Math.floor(n / 100);
  const resto = n % 100;
  const partes: string[] = [];
  if (c > 0) partes.push(CENTENAS[c]);
  if (resto > 0) {
    if (resto < 20) partes.push(UNIDADES[resto]);
    else {
      const d = Math.floor(resto / 10);
      const u = resto % 10;
      partes.push(u ? `${DEZENAS[d]} e ${UNIDADES[u]}` : DEZENAS[d]);
    }
  }
  return partes.join(' e ');
};

const ESCALAS: [number, string, string][] = [
  [1_000_000_000, 'bilhão', 'bilhões'],
  [1_000_000, 'milhão', 'milhões'],
  [1_000, 'mil', 'mil'],
];

// Inteiro por extenso ("mil e quinhentos", "dois milhões e trinta mil").
const inteiroPorExtenso = (valor: number): string => {
  if (valor === 0) return 'zero';
  const grupos: { n: number; texto: string }[] = [];
  let resto = valor;
  for (const [escala, singular, plural] of ESCALAS) {
    const q = Math.floor(resto / escala);
    if (q > 0) {
      const nome = escala === 1_000 ? (q === 1 ? 'mil' : `${ate999(q)} mil`) : `${ate999(q)} ${q === 1 ? singular : plural}`;
      grupos.push({ n: q * escala, texto: nome });
      resto %= escala;
    }
  }
  if (resto > 0) grupos.push({ n: resto, texto: ate999(resto) });
  // "e" antes do último grupo quando ele é < 100 ou centena redonda (ex.: "mil e duzentos").
  return grupos.map((g, i) => {
    if (i === 0) return g.texto;
    const ultimo = i === grupos.length - 1;
    const usaE = ultimo && (g.n < 100 || g.n % 100 === 0);
    return `${usaE ? 'e ' : ''}${g.texto}`;
  }).join(grupos.length > 1 ? ' ' : '').replace(/ {2,}/g, ' ');
};

export const valorPorExtenso = (valor: number): string => {
  const centavosTotais = Math.round(Math.abs(Number(valor) || 0) * 100);
  const reais = Math.floor(centavosTotais / 100);
  const centavos = centavosTotais % 100;
  const partes: string[] = [];
  if (reais > 0) {
    // "um milhão de reais", "dois mil reais".
    const texto = inteiroPorExtenso(reais);
    const de = reais % 1_000_000 === 0 ? ' de' : '';
    partes.push(`${texto}${de} ${reais === 1 ? 'real' : 'reais'}`);
  }
  if (centavos > 0) partes.push(`${ate999(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`);
  return partes.length ? partes.join(' e ') : 'zero real';
};
